/**
 * Format a date string into a user-friendly format (e.g., 25/10/25)
 * @param {string|Date} dateString 
 * @returns {string}
 */
export const formatDateShort = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
};

/**
 * Format a date string into a long format (e.g., 25th October 2025)
 * @param {string|Date} dateString 
 * @returns {string}
 */
export const formatDateLong = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
};
